import moment from 'moment';
import 'moment/locale/th';
var dd = moment.locale('th');
export const ConvertDateShort = (date, format) => {
  return date ? moment(date).add(543, 'year').format(format) : "";
};
